/**
 * AvisoDeVersion.tsx — «hay una versión nueva» y el botón que la toma.
 *
 * ▶ VA MONTADO EN `main.tsx`, FUERA DE `App`, Y ESO ES LO ÚNICO RARO DE ACÁ.
 *
 * `App.tsx` tiene cuatro salidas tempranas antes del enrutador —`/clave`,
 * `/consola`, la pantalla de acceso y la de «elegir empresa»—, así que un aviso
 * puesto dentro sólo saldría en una de ellas. Y la que más lo necesita es
 * justamente la que más tiempo tiene una pestaña abierta sin recargar.
 *
 * Montado al lado de `App` sale en las cinco, y no depende de haber entrado:
 * una versión nueva del cascarón vale igual antes de la sesión que después.
 *
 * ▶ Y se puede posponer. «Después» lo cierra hasta la próxima vez que el
 * navegador vea una versión esperando — no es un «nunca», es un «ahora no».
 * Un aviso que no se puede cerrar se aprende a ignorar, y después se ignora
 * igual el que importa.
 */
import { useEffect, useState } from 'react';
import { registrarTrabajador } from '../nucleo/pwa.ts';
import { useIdioma } from '../nucleo/idioma.tsx';

export function AvisoDeVersion() {
  const { t } = useIdioma();
  const [relevar, setRelevar] = useState<(() => void) | null>(null);

  useEffect(() => {
    // El `() => fn` es a propósito: `setState` con una función la EJECUTA, y
    // sin el envoltorio esto recargaría la pestaña en el momento de enterarse
    // de la versión nueva — justo lo contrario de lo que se busca.
    registrarTrabajador((fn) => setRelevar(() => fn));
  }, []);

  if (!relevar) return null;

  return (
    <div className="aviso-version" role="status">
      <span>{t('ver.hay')}</span>
      <button type="button" className="btn btn--primary btn--sm" onClick={relevar}>
        {t('ver.actualizar')}
      </button>
      <button
        type="button" className="btn btn--ghost btn--sm"
        onClick={() => setRelevar(null)}
      >
        {t('ver.despues')}
      </button>
    </div>
  );
}
